// Shown in place of the setup flow on a site that can't run it (window.site.canOnboard
// is false — mytempstick.com). Pairing a sensor needs the app's native bridge to join
// the sensor's "Sensor Setup" network, and a plain browser has no way to do that, so
// this points people at the app rather than starting a flow that dead-ends at the
// QR scanner.
export class StepAppOnly {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "app_only";
  title = "Set up a Temp Stick";

  template = `
  <div class="onboarding-step" data-for="app_only">
    <div class="onboarding-guide onboarding-app-only">

      <h2 class="onboarding-guide-heading">Sensor setup is done in the Temp Stick app</h2>

      <p class="onboarding-guide-instruction">
        Setting up a Temp Stick takes a phone or tablet: our free app connects directly to the
        sensor to join it to your Wi-Fi, which a web browser can't do.
      </p>

      <p class="onboarding-guide-instruction">
        Download the app, sign in with the same account you use here, and tap
        <b>Add New Temp Stick</b>. Once the sensor is connected it shows up on this dashboard.
      </p>

      <div class="onboarding-browser-app-links">
        <div class="onboarding-browser-app-links__link">
          <a href="https://play.google.com/store/apps/details?id=com.tempstick" target="_blank" rel="noopener">
            <img src="${window.site.home}/../assets/images/app-stores-google-play.png" width="200" alt="Get it on Google Play" title="Android app" />
          </a>
        </div>
        <div class="onboarding-browser-app-links__link">
          <a href="https://apps.apple.com/us/app/temp-stick/id1137756208" target="_blank" rel="noopener">
            <img src="${window.site.home}/../assets/images/app-stores-apple.png" width="200" alt="Download on the App Store" title="iOS app" />
          </a>
        </div>
      </div>

      <div class="onboarding-instruction__actions">
        <button type="button" class="button onboarding-guide-next-btn" data-for="app_only_back">
          Back to Sensors
        </button>
      </div>

    </div>
  </div>
  `;

  onBack = () => {
    window.location.href = window.site.home + '/sensors';
  }

  onActivate = () => {
    this.onboarding.showBackButton();
  }

  bindActions = () => {
    $(this.onboarding.container)
      .find('button[data-for="app_only_back"]')
      .on('click', () => this.onBack());
  }

}
